// @flow
export const bonusRoute = "/mein-remindme/praemien";

export default bonusRoute;

export const paidAnchor = "bezahlt";
export const openAnchor = "offen";
export const waitingAnchor = "warten";
